import { combineReducers } from "redux";
import { usersState } from "./usersReducer";

export const usersReducers = combineReducers({
  usersState: usersState  
});
